import { ExtratoPagarmeFornecedorInicial } from "../models/extratoPagarmeFornecedorModel"
import type { ExtratoPagarmeFornecedorModel } from "../models/extratoPagarmeFornecedorModel"
import { ExtratoPagarmeFornecedorActionsTypes } from "./extratoPagarmeFornecedorActions"
import type { ExtratoPagarmeFornecedorActions } from "./extratoPagarmeFornecedorActions"

const { CARREGAR, SET_DATA_INICIO, SET_DATA_FIM } = ExtratoPagarmeFornecedorActionsTypes

export function extratoPagarmeFornecedorReducer(
    state: ExtratoPagarmeFornecedorModel = ExtratoPagarmeFornecedorInicial,
    action: ExtratoPagarmeFornecedorActions
): ExtratoPagarmeFornecedorModel {
    switch (action.type) {
        case CARREGAR:
            return {
                ...state,
                grupos: action.payload.grupos,
                saldo: action.payload.saldo,
            }
        case SET_DATA_INICIO:
            return { ...state, dataInicio: action.payload }
        case SET_DATA_FIM:
            return { ...state, dataFim: action.payload }
        default:
            return state
    }
}
